<template>
	<div class="page with-logo">
		<div class="logo-text">
			<div></div>
		</div>
		<h1 class="what">{{ basketEntities.length > 0 ? 'Add events to your promotion' : 'Start Promotion'}}</h1>
		<Basket
			v-if="basketEntities.length > 0"
			:basket-entities="basketEntities"
			@remove="removeEntityFromBasket"
			@goToSearch="goToWithSeeds('search')"
			@goToConfigure="goToWithSeeds('configure')"/>
		<div v-if="chosenEventIsTooSoon">
			<p>Hello! We can’t automatically boost your event as it takes place very soon.</p>
			<p>But if you <a href="mailto:backstage@ents24.com" target="_blank">get in touch</a>, we’ll get back to you ASAP, and it’s likely we’ll still be able to promote it.</p>
			<button @click="chosenEventIsTooSoon = false" class="button">Search</button>
		</div>
		<Search
			v-else
			@inputfocus="scrollToWhat"
			@event-selected="addEvent"
			@owner-selected="goToOwner"
			:earliestPromotionIso="config.earliestPromotionIso"
			:shortestPromotionWindow="config.shortestPromotionWindow" />
	</div>
</template>

<script>
	import axios             from 'axios';
	import { EventBus }      from '../../event-bus';
	import Search            from '../Search'
	import Basket            from '../Basket'
	import basketHolderMixin from '../../mixins/basketHolder.js'
	import { eventIsPromotable } from '../../date-utils';

	export default {
		components: {
			Search,
			Basket
		},
		props: [
			'config',
		],
		data() {
			return {
				pageState : 'loading',
				chosenEventIsTooSoon: false,
			}
		},

		mixins : [
			basketHolderMixin
		],

		methods : {
			/**
			 * Position the search input on mobile devices so that the results
			 * are not hidden beneath the software keyboard
			 */
			scrollToWhat() {
				if(this.isTouchDevice()) {
					this.scrollToSelector('.what');
				}
			},

			isTouchDevice() {
				return 'ontouchstart' in document.documentElement;
			},

			addEvent(event) {
				this.chosenEventIsTooSoon = false

				if(eventIsPromotable(event, this.config.earliestPromotionIso, this.config.shortestPromotionWindow)) {
					this.addEntitiesToBasket(event, 'items')
				} else {
					this.chosenEventIsTooSoon = true
				}

			},

			goToOwner(owner) {
				EventBus.$emit('update-owner', owner);

				this.$router.push({
					name   : 'owner',
					params : {
						ownerType : owner.entityType,
						ownerId   : owner.entityId,
						basket    : JSON.stringify(this.basket)
					}
				})
			},

			/**
			 * Single scroll func to DRY and standardise
			 * @param  {String} selector what el to scroll to
			 */
			scrollToSelector (selector) {
				let options = {
					behavior : 'smooth',
					block    : 'start',
					inline   : 'nearest'
				}

				setTimeout( () => this.$el.querySelector(selector).scrollIntoView(options),	300);
			},

			lookupEntity(entityType, entityId) {
				return axios.get(this.$baseApiUrl + `/events/${entityType}/${entityId}`)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		// Allow space for search <input>, calendars etc. to be scolled to the top, even when there is no content below them
		// XK: This serves as a partial fix for the CalendarPair scroll glitch where <transition> is briefly empty
		min-height : 2100px;
	}

	.calendar {

		.c-day-content {

			// XK: "fix" for calendar selected day BG not inline issue
			// Removing Roboto import also fixes...
			div {
				height    : 100%;
				transform : translateY(28%);
			}
		}
	}
</style>

